import * as Sentry from "@sentry/angular";
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from "./environments/environment";

if (environment.production) {
  Sentry.init({
    dsn: "https://9b9e06945f9d3133b821a4011bc893d8@o4510417623318528.ingest.us.sentry.io/4510417623646208",
    integrations: [
      Sentry.browserTracingIntegration(), 
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
        maskAllInputs: false
      }),
      Sentry.captureConsoleIntegration(
        {
          levels: ['error', 'warn']
        }
      ),
      Sentry.consoleLoggingIntegration({ levels: ["info", "log", "warn", "error"] }),
    ],
    tracesSampleRate: 1,
    replaysSessionSampleRate: 0.75,
    replaysOnErrorSampleRate: 1,
    enableLogs: true,
    sendDefaultPii: true
  })
}



platformBrowserDynamic().bootstrapModule(AppModule, {
  ngZoneEventCoalescing: true
})
  .catch(err => console.error(err));